import { Injectable } from '@angular/core';
import { CanActivate, Route, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';
import { UserPermissionsService } from '../shared/services/user-permissions.service';
import { SessionService } from '../shared/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private permissionAcess: boolean;
  private role;

  constructor(private loginService: LoginService,
    private userPermissionsService: UserPermissionsService,
    private sessionService: SessionService,
    private router: Router) {
      this.role = this.sessionService.role;
      this.loginService.isLoggedIn().subscribe(
        response => this.permissionAcess = response
      );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable < boolean > | Promise < boolean > | boolean {
    return this.checkAccess();
  }

  canLoad(route: Route): Observable < boolean > | Promise < boolean > | boolean {
    return this.checkAccess();
  }

  checkAccess() {
    // NOTE Verifica antes o tipo do perfil logado
    if (this.permissionAcess) {
      if (this.role === 'ROLE_PARTICIPANTE') {
        this.getDataParticipante();
      }
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }

  /*
    NOTE Se o participante ainda nao concluiu o cadastro
    será jogado sempre para a tela de cadastro completo
  */
  private getDataParticipante(): void {
    this.userPermissionsService.readTokenData().subscribe(
      success => {
        if (success.preCadastro) {
          this.router.navigate(['/area-do-participante/cadastro']);
        }
      }
    );
  }

}
